"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductItemValueLimit = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _tickCrossIcons = require("./tickCrossIcons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var ProductItemValueLimit = exports.ProductItemValueLimit = function ProductItemValueLimit(_ref) {
  var labelKey = _ref.labelKey,
    valueMap = _ref.valueMap,
    productDefinition = _ref.productDefinition,
    formatters = _ref.formatters;
  var limits = productDefinition.limits;
  var limitDefinition = limits[labelKey];
  if (valueMap && limits[valueMap.value]) {
    limitDefinition = limits[valueMap.value];
  }
  var applyFormat = function applyFormat(derivedValue) {
    if (formatters && formatters.value) {
      return formatters.value(derivedValue);
    }
    return derivedValue;
  };
  if (labelKey in productDefinition.customCoverDetails) {
    var baseValue = productDefinition.customCoverDetails[labelKey];
    return /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
      value: baseValue
    });
  }
  if (!limitDefinition || _typeof(limitDefinition) === 'object' && Object.keys(limitDefinition).length === 0) {
    return 'No sub-limit';
  }
  if (limitDefinition.displayValue) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "limitsText"
    }, applyFormat(limitDefinition.displayValue));
  }

  // Assume the limit definition is a string
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "limitsText"
  }, applyFormat(limitDefinition));
};
ProductItemValueLimit.propTypes = {
  labelKey: _propTypes["default"].string,
  valueMap: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  formatters: _propTypes["default"].shape({
    label: _propTypes["default"].func,
    value: _propTypes["default"].func
  }),
  /* eslint-disable-next-line react/forbid-prop-types */
  productDefinition: _propTypes["default"].any // TODO: Create a propType model once this is finalised
};
var _default = exports["default"] = {
  ProductItemValueLimit: ProductItemValueLimit
};